import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { PromotionsListRequest, SpinningWheelComponent } from "../spinning-wheel/spinning-wheel.component";
import { IcecashReportsService } from '../../service/icecash-reports.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';

export interface Region {
  display: string;
  value: string;
}
@Component({
  selector: 'app-promotions',
  standalone: true,
  imports: [CommonModule, ToastModule, SpinningWheelComponent, TabViewModule],
  templateUrl: './promotions.component.html',
  styleUrl: './promotions.component.scss',
  providers: [MessageService]
})
export class PromotionsComponent implements OnInit {
  promotionsService = inject(IcecashReportsService);
  messageService = inject(MessageService);

  promoWinner: any=null;
  vehicles: any[] = [];
  loadingPromoItems: boolean = false;
  spinning=false;

  ngOnInit() {
    //this.fetchRecords()
  }

  onRouletteSelect(event: any) {
    console.log(event);
  }

  regions = [
    {
      display: 'Bulawayo',
      value: 'Bulawayo'
    },
    {
      display: 'Harare',
      value: 'Harare'
    },
    {
      display: "Masvingo",
      value: "Masvingo"
    },
    {
      display: "Mutare",
      value: "Mutare"
    },
    {
      display: "Gweru",
      value: "Gweru"
    },
    {
      display: "Ruwa",
      value: "Ruwa"
    },
    {
      display: "Gwanda",
      value: "Gwanda"
    },
    {
      display: "Marondera",
      value: "Marondera"
    },
    {
      display: "Kadoma",
      value: "Kadoma"
    }
  ]

  winnerSaved(event: any) {
    if (event.type === 'SUCCESS') {
      this.showSuccess("Winner saved successfully");
    } else {
      this.showError("Could not save the winner");
    }
  }


  loadPromoItems(event: PromotionsListRequest) {
    this.loadingPromoItems = true;
    this.promotionsService.fetchPromoItems(this.formatDate(event.dateFrom).toString()+':00.000Z', this.formatDate(event.dateTo).toString()+':00.000Z', event.status, event.region, event.promotionId).subscribe({
      next: value => {
        this.promoWinner = value;
        this.vehicles = value.motorInsurancePromotionList
        this.loadingPromoItems = false;
        console.log(this.promoWinner)
        this.showSuccess('Winner found')
      },
      error: err => {
        this.loadingPromoItems = false;
        this.showError('Failed to load promotion clients. Please try again later.')
      }
    })
  }

  formatDate(inputDate: string): string {
    const date = new Date(inputDate);
    return (
      date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, "0") + "-" +
      String(date.getDate()).padStart(2, "0") + "T" +
      String(date.getHours()).padStart(2, "0") + ":" +
      String(date.getMinutes()).padStart(2, "0"));
  }

  showSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
  }


  showError(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }
}
